import i18next from "i18next";
import { observable } from "s2-engine";

import router, {
  EVENT_CHANGE_ROUTE,
  EVENT_LOADED_DATA,
} from "@/__main__/router.mjs";
import { hideSearch, setSearchQuery, showSearch } from "@/search/actions.mjs";
import type { SearchResultGroup } from "@/search/types.d.mjs";
import { findGameSymbol } from "@/util/game-route.mjs";
import globals from "@/util/global-whitelist.mjs";
import { listenHotkey } from "@/util/use-hotkey.mjs";

const omniSearchState = observable({
  show: false,
  query: "",
  results: [] as SearchResultGroup[] & {
    headline?: Translation;
    query?: string;
    ms?: number;
    loading?: boolean;
    total?: number;
    players?: {
      ms: number;
      count: number;
    };
  },
  lang: "",
  currentPath: "",
  game: null,
});

globals.__BLITZ_DEV__.omniSearchState = omniSearchState;

i18next.on("languageChanged", (lang) => {
  omniSearchState.lang = lang;
});

function setup() {
  listenHotkey("Ctrl+Enter", showSearch);
  listenHotkey("Escape", hideSearch);

  router.events.on(EVENT_CHANGE_ROUTE, (route) => {
    omniSearchState.currentPath = route.currentPath;
    setSearchGame();
  });
}

export const setSearchGame = (game?: symbol) => {
  if (!game) {
    // do not auto-set the game if the search modal is open
    if (omniSearchState.show) return;
    game = findGameSymbol();
  }
  omniSearchState.game = game;
};

queueMicrotask(setup);

// clear the search input and hide the search modal when navigation is complete
export function clearSearchAfterRouted() {
  router.events.once(EVENT_LOADED_DATA, () => {
    hideSearch();
    omniSearchState.query = "";
    setSearchQuery("");
  });
}

export default omniSearchState;
